export const PrivacyPolicyContent = {
  Title: 'Privacy Policy',
  Content: `
    **Effective date:** April 18, 2026

    Digital Porters ("we", "us", "our") operates digitalporters.com (the "Site"). This Privacy Policy explains what information we collect when you use the Site, how we use it, and the choices you have.

    # Information We Collect
    - **Contact form submissions:** When you fill out the contact form, we collect the name, email address, phone number, and message you provide.
    - **AI chat conversations:** When you use our chat assistant, we process the messages you send so the assistant can respond. Conversations may be stored to improve service quality and follow up on inquiries.
    - **Analytics and usage data:** We use Google Analytics to collect aggregated information about how visitors interact with the Site, including pages viewed, time on page, browser, device type, and approximate location.
    - **Cookies and similar technologies:** Google Analytics and reCAPTCHA set cookies to distinguish users and protect the Site from abuse.

    # How We Use Your Information
    - To respond to inquiries you send us through the contact form or chat assistant.
    - To provide, maintain, and improve the Site and our services.
    - To prevent spam and abuse (via Google reCAPTCHA).
    - To understand how the Site is used and improve its performance.

    # Third-Party Services
    We rely on the following third parties to operate the Site. Each processes information according to its own privacy policy:
    - **EmailJS** — delivers contact form submissions to our inbox.
    - **Airtable** — stores contact submissions for follow-up.
    - **Google reCAPTCHA v3** — spam and abuse prevention.
    - **Google Analytics** — website usage analytics.
    - **AI Spine** — powers our chat assistant.
    - **Hostinger / Cloudflare / AWS CloudFront** — hosting and content delivery.

    We do not sell your personal information.

    # Data Retention
    We keep contact submissions and chat records for as long as necessary to respond to your inquiry and maintain business records. You may request deletion at any time by contacting us.

    # Your Rights
    Depending on where you live, you may have the right to access, correct, delete, or export the personal information we hold about you, and to object to or restrict certain uses. To exercise any of these rights, contact us at [hello@digitalporters.com](mailto:hello@digitalporters.com).

    # Security
    We take reasonable administrative and technical measures to protect your information. However, no method of transmission over the internet or electronic storage is completely secure.

    # Children
    The Site is not directed to children under 13, and we do not knowingly collect personal information from children.

    # Changes to This Policy
    We may update this Privacy Policy from time to time. When we do, we will revise the effective date above and post the updated policy on this page.

    # Contact
    If you have questions about this Privacy Policy or our data practices, contact us at [hello@digitalporters.com](mailto:hello@digitalporters.com).
  `
};
